import { getCountries } from '@change-corgi/config/countries';
import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_EXPORT_SIGNATURE_BLOCKLIST = defineFcm('export_signature_blocklist')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				petitionIds: { type: 'array', shape: { type: 'string' } },
				countryCodeIds: { type: 'array', shape: { type: 'enum', values: getCountries() } },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'blocked_signature_export',
		description: 'FCM to block signature export for a petition by country code.',
		import: false,
		template: {
			petitionIds: ['12345', '67890'],
			countryCodeIds: ['US', 'CA'],
		},
	});
